import { Helmet } from 'react-helmet';
import { Col, Row, Skeleton, Space } from 'antd';

import { useGetToolByIdQuery } from 'app/services/tools';
import Details from './components/Details';
import Logs from './components/Logs';
import Tabs from './components/Tabs';
import useUrlParameter from 'utils/useUrlParameter';

const View = () => {
  const id = useUrlParameter<number>('id');
  const { data: tool, isLoading: toolLoading } = useGetToolByIdQuery(id);

  if (toolLoading || !tool) return <Skeleton active />;

  return (
    <>
      <Helmet title={'Kvalilog'}/>
      <Space direction="vertical" size="middle" className='antd-space' style={{ display: 'flex' }}>
        <Row>
          <Col span={24}>
            <Details tool={tool} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Tabs tool={tool}/>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Logs tool={tool}/>
          </Col>
        </Row>
      </Space>
    </>
  );
};

export default View;
